export enum BooleanFilter {
  ALL = -1,
  NO,
  YES
}
